// Utility function to extract board ID from Monday.com context
export function extractBoardId(context) {
  if (!context) {
    return null;
  }
  
  // Board view context - try different possible structures
  if (context.boardId) {
    return Number(context.boardId);
  }
  if (context.boardIds && context.boardIds.length > 0) {
    return Number(context.boardIds[0].id || context.boardIds[0]);
  }
  if (context.board) {
    return Number(context.board.id);
  }
  return null;
}

